import { Outlet, useLocation } from 'react-router-dom'
import { Nav } from '@/components/landing/Nav'
import { Footer } from '@/components/landing/Footer'
import '@/styles/landing.css'

export default function PublicLayout() {
  // The Nav is fixed and transparent so it can overlay the landing hero
  // (which is full-bleed under it). Non-hero public pages (pricing, aesthetics)
  // need top padding so their content clears the fixed bar.
  const isLanding = useLocation().pathname === '/'
  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1" style={isLanding ? undefined : { paddingTop: 76 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
